module.exports = __webpack_public_path__ + "static/media/sport-banner-exchange.731106b9.png";